import React from 'react'
import { Modal, ModalBody, ModalHeader } from 'reactstrap'
import PropTypes from 'prop-types'

export default class CustomModal extends React.Component {

    render() {
        return (
            <Modal isOpen={this.props.isOpen} className={this.props.className}>
                <ModalHeader className="custom-modal-header" toggle={this.props.toggle}>{this.props.title}</ModalHeader>
                <ModalBody>
                    {/** Injection du composant enfant */}
                    {this.props.children}
                </ModalBody>
            </Modal>
        )
    }
}

CustomModal.propTypes = {
    isOpen: PropTypes.bool,
    toggle: PropTypes.func,
    title: PropTypes.string,
    validate: PropTypes.func,
    className: PropTypes.string
}
CustomModal.defaultProps = {
    className: ''
}